// extracted by mini-css-extract-plugin
export default {"botao":"BotaoVoltarTopo_botao__5gbSL","visivel":"BotaoVoltarTopo_visivel__LuC41"};